import React, { useState, useEffect } from "react";
import { red } from '@material-ui/core/colors';
import axios from 'axios';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TableFooter,
    TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';

import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input
} from 'reactstrap';

import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSImage from "components/Forms/TSImage";
import TSUser from "components/Forms/TSUser";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import ConfirmModal from "components/Modal/ConfirmModal";
import moment from 'moment';
import 'moment/locale/th';

const host = '';

const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
        flexGrow: 1,
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
        flexGrow: 1,
    },
    tableContainer: {
        width: '99.99%',
        overflowX: 'auto',
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        padding: '2px',
    },
    modalFullscreen: {
        width: '100%',
        height: '100%',
        margin: 0,
        maxWidth: '100%',
    },
}));

const BorrowStatus = [
    { value: 0, label: 'ขออนุมัติยืม', color: 'orange' },
    { value: 1, label: 'กำลังยืม', color: 'blue' },
    { value: 2, label: 'คืนแล้ว', color: 'green' },
    { value: 3, label: 'เลยกำหนด', color: 'red' },
    { value: 4, label: 'สูญหาย', color: 'red' },
    { value: 5, label: 'ชำรุด', color: 'red' },
];

var currentUser = JSON.parse(localStorage.getItem('currentUser'))

const AssetBorrowList = (props) => {
    const classes = useStyles();

    const [borrowRecords, setBorrowRecords] = useState([]);
    const [assets, setAssets] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [borrowImages, setBorrowImages] = useState([]);
    const [selectedReturnFiles, setSelectedReturnFiles] = useState([]);
    const [returnImages, setReturnImages] = useState([]);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    // Filters
    const [TypeKey, setTypeKey] = useState('');
    const [CategoryKey, setCategoryKey] = useState('');

    const [AssetKey, setAssetKey] = useState(
        new URLSearchParams(props.location?.search).get('assetKey') || ''
    );

    const [StatusKey, setStatusKey] = useState('');
    const [Keyword, setKeyword] = useState('');
    const [AssetOwnerText, setAssetOwnerText] = useState('');
    const [isOwner, setIsOwner] = useState(false);

    // Dropdown data
    const [ArrAssetType, setAssetType] = useState([]);
    const [ArrCategory, setCategory] = useState([]);

    // Page & order
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('BorrowDT');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    // Pre-selected asset info
    const [preSelectedAsset, setPreSelectedAsset] = useState(null);

    useEffect(() => {
        fetchAssetType();
    }, []);

    useEffect(() => {
        fetchCategory(TypeKey);
    }, [TypeKey]);

    useEffect(() => {
        fetchBorrowRecords();
    }, [AssetKey,TypeKey, CategoryKey, Keyword]);

    useEffect(() => {
        if (AssetKey && AssetKey !== '' && assets.length > 0) {
            const asset = assets.find(a => a.assetKey === parseInt(AssetKey));
            if (asset) {
                setPreSelectedAsset(asset);
            }
        }
    }, [AssetKey, assets]);

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const fetchAssetType = async () => {
        try {
            const response = await axios.get(host + '/api/v1/asset/assettype');
            const json = JSON.parse(JSON.stringify(response.data.data).split('"name":').join('"label":').split('"typeKey":').join('"value":'));
            setAssetType(json);
        } catch (error) {
            console.error('Error fetching asset types:', error);
        }
    };

    const fetchCategory = async (typeKey) => {
        try {
            const response = await axios.get(host + '/api/v1/asset/category?typeKey=' + typeKey);
            const json = JSON.parse(JSON.stringify(response.data.data).split('"name":').join('"label":').split('"categoryKey":').join('"value":'));
            if (response.data.result === 200) {
                setCategory(json);
            } else {
                setCategory([]);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            setCategory([]);
        }
    };

    const fetchAssets = async () => {
        try {
            const response = await axios.get(host + '/api/v1/asset?name=' + Keyword + '&typeKey=' + TypeKey + '&categoryKey=' + CategoryKey);
            if (response.data.result === 200) {
                setAssets(response.data.data);
            } else {
                setAssets([]);
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
            setAssets([]);
        }
    };

    const fetchBorrowRecords = async () => {
        try {
            // First fetch assets based on filters
            await fetchAssets();

            const params = new URLSearchParams();
            if (AssetKey && AssetKey !== '') params.append('assetKey', AssetKey);
            if (StatusKey && StatusKey !== '') params.append('statusKey', StatusKey);

            const response = await axios.get(host + '/api/v1/asset/borrow?' + params.toString());
            if (response.data.result === 200) {
                let data = response.data.data;

                if (Keyword && Keyword.length >= 3) {
                    data = data.filter(r =>
                        (r.Asset && r.Asset.Name && r.Asset.Name.toLowerCase().includes(Keyword.toLowerCase())) ||
                        (r.BorrowDocNo && r.BorrowDocNo.toLowerCase().includes(Keyword.toLowerCase())) ||
                        (r.Borrower && r.Borrower.firstName && r.Borrower.firstName.toLowerCase().includes(Keyword.toLowerCase()))
                    );
                }

                setBorrowRecords(data);
            }
        } catch (error) {
            console.error('Error fetching borrow records:', error);
            setBorrowRecords([]);
        }
    };
/*
    const fetchBorrowImages = async (borrowID) => {
        try {
            const response = await axios.get(host + '/api/v1/asset/borrowimage/' + borrowID);
            if (response.data.result === 200) {
                setBorrowImages(response.data.data);
            } else {
                setBorrowImages([]);
            }
        } catch (error) {
            console.error('Error fetching borrow images:', error);
            setBorrowImages([]);
        }
    };
*/
    const fetchBorrowImages = async (borrowID) => {
        try {
            const response = await axios.get(host + '/api/v1/asset/borrowimage/' + borrowID);
            
            if (response.data.result === 200 && Array.isArray(response.data.data)) {
                const allImages = response.data.data;
                console.log(allImages)
                // แยกรูปที่ FileObjectKey ขึ้นต้นด้วย 'borrow'
                const borrowImgs = allImages.filter(img => 
                    img.fileObjectKey && img.fileObjectKey.toLowerCase().startsWith('borrow')
                );

                // แยกรูปที่ FileObjectKey ขึ้นต้นด้วย 'return'
                const returnImgs = allImages.filter(img => 
                    img.fileObjectKey && img.fileObjectKey.toLowerCase().startsWith('return')
                );

                // อัปเดต State ทั้งสองตัว
                setBorrowImages(borrowImgs);
                setReturnImages(returnImgs);

            } else {
                // กรณีที่ Result ไม่ใช่ 200 หรือไม่มีข้อมูล ให้เคลียร์ค่าเป็น Array ว่าง
                setBorrowImages([]);
                setReturnImages([]);
            }
        } catch (error) {
            console.error('Error fetching borrow images:', error);
            setBorrowImages([]);
            setReturnImages([]);
        }
    };
    const handleEdit = (index, record) => {
        setEditIndex(index);
        setIsEditing(true);
        setSelectedRecord({ ...record });
        setModalOpen(true);
        if (record.borrowID) {
            fetchBorrowImages(record.borrowID);
        }
    };

    const handleAdd = () => {
        const newRecord = {
            borrowKey: null,
            assetKey: AssetKey && AssetKey !== '' ? parseInt(AssetKey) : null,
            borrowerCode: null,
            borrowDT: null,
            expectedReturnDT: null,
            actualReturnDT: null,
            borrowCondition: null,
            returnCondition: null,
            remark: null,
            statusKey: 1,
            approverCode: null,
            receiverCode: null,
            creatorCode: null,
            createDatetime: null,
            lastEditerCode: null,
            lastEditDatetime: null,
        };

        setSelectedRecord(newRecord);
        setIsEditing(false);
        setEditIndex(null);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedRecord(null);
        setIsEditing(false);
        setEditIndex(null);
        setSelectedFiles([]);
        setSelectedReturnFiles([]);
        setBorrowImages([]);
        setPreviewModalOpen(false);
        setPreviewImage('');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedRecord({ ...selectedRecord, [name]: value });
    };

    const handleSelectChange = (name, value) => {
        if(name == 'assetKey')
        {
            const asset = assets.find(a => a.assetKey === parseInt(value));
            console.log(value)
            console.log(asset)

            setAssetOwnerText(asset.userView != null ? `${asset.userView.firstName} ${asset.userView.lastName}`: 'ไม่ระบุ');

            setIsOwner(asset.userCode == currentUser.userName)
           
        }
     
        setSelectedRecord({ ...selectedRecord, [name]: value });

    };
    
    const [isLoading, setIsLoading] = useState(false); // เพิ่ม state เพื่อคุม Spinner
    const handleSaveChanges = async () => {
        try {
            setIsLoading(true); // เริ่มแสดง Spinner

            let payload = { ...selectedRecord };
            if (selectedFiles.length > 0) {
                const base64Files = await Promise.all(selectedFiles.map(file => fileToBase64(file)));
                payload.borrowFiles = base64Files;
            }

            if (selectedReturnFiles.length > 0) {
                const base64Files = await Promise.all(selectedReturnFiles.map(file => fileToBase64(file)));
                payload.returnFiles = base64Files;
            }

            if (isEditing && selectedRecord.borrowID) {
                await axios.put(host + '/api/v1/asset/borrow/' + selectedRecord.borrowID, payload);
            } else {
                await axios.post(host + '/api/v1/asset/borrow', payload);
            }

            setConfirmOpen(false); // ปิด Confirm Modal
            handleCloseModal();     // ปิด Edit Modal
            fetchBorrowRecords();
        } catch (error) {
            console.error("Error saving borrow record:", error);
        } finally {
            setIsLoading(false); // ปิด Spinner
        }
    };

    const openConfirmModal = () => {
        setConfirmOpen(true);
    };

    const handleDownloadImage = async () => {
        if (!previewImage) return;
        try {
            const response = await axios.get(host + '/api/v1/file/asset/' + previewImage, {
                responseType: 'blob',
            });

            let fileName = 'downloaded-image';
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = decodeURIComponent(fileNameMatch[1]);
                } else {
                    const fileNameMatchSimple = contentDisposition.match(/filename="([^"]+)"/);
                    if (fileNameMatchSimple && fileNameMatchSimple[1]) {
                        fileName = fileNameMatchSimple[1];
                    }
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading image:', error);
            alert('Cannot download image');
        }
    };

    const handleReturn = async (borrowID) => {
        try {
            await axios.post(host + '/api/v1/asset/borrow/' + borrowID + '/return', {
                actualReturnDT: new Date().toISOString(),
                returnCondition: 'ดี',
                remark: 'คืนปกติ'
            });
            fetchBorrowRecords();
        } catch (error) {
            console.error("Error returning asset:", error);
        }
    };
    
    const handleDelete = async (borrowID) => {
        if (window.confirm('ต้องการลบรายการนี้?')) {
            try {
                await axios.delete(host + '/api/v1/asset/borrow/' + borrowID);
                fetchBorrowRecords();
            } catch (error) {
                console.error("Error deleting record:", error);
            }
        }
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedRecords = () => {
        return [...borrowRecords].sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getStatusLabel = (statusKey) => {
        const status = BorrowStatus.find(s => s.value === statusKey);
        return status ? status.label : '';
    };

    const getStatusColor = (statusKey) => {
        const status = BorrowStatus.find(s => s.value === statusKey);
        return status ? status.color : 'black';
    };

    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>รายการยืม-คืนครุภัณฑ์</h4>
                            <p className={classes.cardCategoryWhite}>
                                {preSelectedAsset && `สินทรัพย์ที่เลือก: ${preSelectedAsset.Name} (${preSelectedAsset.DocNo})`}
                            </p>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                <Col xs={12} sm={12} md={4}>
                                    <TSText
                                        icon="far fa-edit"
                                        label="คำค้นหา"
                                        value={Keyword}
                                        onChange={e => setKeyword(e.target.value)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <TSSelect2
                                        isClearable={true}
                                        label="ประเภท"
                                        options={ArrAssetType}
                                        value={TypeKey}
                                        onChange={e => setTypeKey(e != null ? e.value : '')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <TSSelect2
                                        isClearable={true}
                                        label="หมวด"
                                        options={ArrCategory}
                                        value={CategoryKey}
                                        onChange={e => setCategoryKey(e != null ? e.value : '')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2
                                        isClearable={true}
                                        label="ครุภัณฑ์"
                                        options={assets.map(a => ({ value: a.assetKey, label: `${a.docNo} - ${a.name}` }))}
                                        value={AssetKey}
                                        onChange={e => setAssetKey(e != null ? e.value : '')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2
                                        isClearable={true}
                                        label="สถานะ"
                                        options={BorrowStatus}
                                        value={StatusKey}
                                        onChange={e => setStatusKey(e != null ? e.value : '')}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                                    <Button2
                                        color="success"
                                        type="button"
                                        onClick={handleAdd}
                                    >
                                        <h4><i className="fa fa-plus"> ยืมครุภัณฑ์</i></h4>
                                    </Button2>
                                </Col>
                            </Grid>

                            <TableContainer component={Paper} className={classes.tableContainer}>
                                <Table className={classes.table} aria-label="borrow table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <TableSortLabel
                                                    active={orderBy === 'BorrowDocNo'}
                                                    direction={orderBy === 'BorrowDocNo' ? orderDirection : 'asc'}
                                                    onClick={() => handleRequestSort('BorrowDocNo')}
                                                >
                                                    เลขที่เอกสาร
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>ครุภัณฑ์</TableCell>
                                            <TableCell>ผู้ยืม</TableCell>
                                            <TableCell>
                                                <TableSortLabel
                                                    active={orderBy === 'BorrowDT'}
                                                    direction={orderBy === 'BorrowDT' ? orderDirection : 'asc'}
                                                    onClick={() => handleRequestSort('BorrowDT')}
                                                >
                                                    วันที่ยืม
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>วันที่คาดว่าจะคืน</TableCell>
                                            <TableCell>วันที่คืนจริง</TableCell>
                                            <TableCell>
                                                <TableSortLabel
                                                    active={orderBy === 'StatusKey'}
                                                    direction={orderBy === 'StatusKey' ? orderDirection : 'asc'}
                                                    onClick={() => handleRequestSort('StatusKey')}
                                                >
                                                    สถานะ
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>การดำเนินการ</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortedRecords()
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((record, index) => (
                                                <TableRow key={record.borrowKey} className={classes.tableRow}>
                                                    <TableCell className={classes.tableCell}>{record.borrowDocNo}</TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {record.asset ? `${record.asset.docNo} - ${record.asset.name}` : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {record.borrower ? `${record.borrower.firstName} ${record.borrower.lastName}` : record.borrowerCode}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {record.borrowDT ? moment(record.borrowDT).format('DD/MM/YYYY') : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {record.expectedReturnDT ? moment(record.expectedReturnDT).format('DD/MM/BBBB') : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {record.actualReturnDT ? moment(record.actualReturnDT).format('DD/MM/BBBB') : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell} style={{ color: getStatusColor(record.statusKey) }}>
                                                        {getStatusLabel(record.statusKey)}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        <Button
                                                            color="primary"
                                                            size="small"
                                                            onClick={() => handleEdit(index, record)}
                                                        >
                                                            <i className="fa fa-edit" /> แก้ไข
                                                        </Button>
                                                        {record.statusKey === 1 && (
                                                            <Button
                                                                color="success"
                                                                size="small"
                                                                onClick={() => handleReturn(record.borrowID)}
                                                                style={{ marginLeft: '5px' }}
                                                            >
                                                                <i className="fa fa-reply" /> คืน
                                                            </Button>
                                                        )}
                                                        <Button
                                                            color="danger"
                                                            size="small"
                                                            onClick={() => handleDelete(record.borrowID)}
                                                            style={{ marginLeft: '5px' }}
                                                        >
                                                            <i className="fa fa-trash" /> ลบ
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                count={borrowRecords.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </CardBody>
                        <CardFooter>
                            <Modal isOpen={modalOpen} toggle={handleCloseModal} className={classes.modalFullscreen}>
                                <ModalHeader toggle={handleCloseModal}>
                                    {isEditing ? 'แก้ไขรายการยืม-คืน' : 'ยืมครุภัณฑ์'}
                                </ModalHeader>
                                <ModalBody>
                                    {selectedRecord && (
                                        <Card>
                                            <CardHeader color="primary">
                                                <h4 className={classes.cardTitleWhite}>
                                                    {isEditing ? 'แก้ไขรายการยืม-คืน ' + selectedRecord.asset.docNo + ' ' + selectedRecord.asset.name : 'ยืมครุภัณฑ์'}
                                                </h4>
                                            </CardHeader>
                                            <CardBody>
                                                <Grid>
                                                    {!isEditing ? 
                                                    <>
                                                    <Col xs={12} sm={12} md={4}>
                                                        <TSText
                                                            icon="far fa-edit"
                                                            label="คำค้นหา"
                                                            value={Keyword}
                                                            onChange={e => setKeyword(e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={6} md={4}>
                                                        <TSSelect2
                                                            isClearable={true}
                                                            label="ประเภท"
                                                            options={ArrAssetType}
                                                            value={TypeKey}
                                                            onChange={e => setTypeKey(e != null ? e.value : '')}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={6} md={4}>
                                                        <TSSelect2
                                                            isClearable={true}
                                                            label="หมวด"
                                                            options={ArrCategory}
                                                            value={CategoryKey}
                                                            onChange={e => setCategoryKey(e != null ? e.value : '')}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSSelect2
                                                            label="ครุภัณฑ์"
                                                            name="assetKey"
                                                            options={assets.map(a => ({ value: a.assetKey, label: `${a.docNo} - ${a.name}` }))}
                                                            value={selectedRecord.assetKey || ''}
                                                            onChange={e => handleSelectChange('assetKey', e != null ? e.value : '')}
                                                            disabled={isEditing || (AssetKey && AssetKey !== '')}
                                                        />
                                                       <Label>ผู้รับผิดชอบ : {AssetOwnerText}</Label>
                                                    </Col>
                                                    </> 
                                                    : 
                                                    <></>
                                                    }
                                                    

                                                    <Col xs={12} sm={6} md={6}>
                                                        <Label>วันที่ยืม</Label>
                                                        <Datetime
                                                            value={moment(selectedRecord.borrowDT).isValid() ? moment(selectedRecord.borrowDT) : null}
                                                            inputProps={{
                                                                name: "borrowDT",
                                                                placeholder: "วันที่ยืม",
                                                                readOnly: 'readonly',
                                                                style: {
                                                                    fontSize: '1.2em',
                                                                    borderRadius: 0,
                                                                    paddingLeft: '50px',
                                                                    cursor: 'pointer',
                                                                    background: '#ffffff',
                                                                    color: '#000000'
                                                                },
                                                                value: moment(selectedRecord.borrowDT).isValid()
                                                                    ? moment(selectedRecord.borrowDT).format('D MMMM BBBB')
                                                                    : ''
                                                            }}
                                                            closeOnSelect={true}
                                                            closeOnTab={true}
                                                            dateFormat="D MMMM BBBB"
                                                            timeFormat={false}
                                                            onChange={e => handleSelectChange('borrowDT', e != null ? e.format('YYYY-MM-DD') : '')}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={6} md={6}>
                                                        <Label>วันที่คาดว่าจะคืน</Label>
                                                        <Datetime
                                                            value={moment(selectedRecord.expectedReturnDT).isValid() ? moment(selectedRecord.expectedReturnDT) : null}
                                                            inputProps={{
                                                                name: "expectedReturnDT",
                                                                placeholder: "วันที่คาดว่าจะคืน",
                                                                readOnly: 'readonly',
                                                                style: {
                                                                    fontSize: '1.2em',
                                                                    borderRadius: 0,
                                                                    paddingLeft: '50px',
                                                                    cursor: 'pointer',
                                                                    background: '#ffffff',
                                                                    color: '#000000'
                                                                },
                                                                value: moment(selectedRecord.expectedReturnDT).isValid()
                                                                    ? moment(selectedRecord.expectedReturnDT).format('D MMMM BBBB')
                                                                    : ''
                                                            }}
                                                            closeOnSelect={true}
                                                            closeOnTab={true}
                                                            dateFormat="D MMMM BBBB"
                                                            timeFormat={false}
                                                            onChange={e => handleSelectChange('expectedReturnDT', e != null ? e.format('YYYY-MM-DD') : '')}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                       <div className="textarea-container" style={{ padding: 0 }}>
                                                            <Label for="description">คำอธิบาย </Label>  
                                                                <Input
                                                                                              id="description"
                                                                                              cols="80"
                                                                                              name="description"
                                                                                              placeholder="คำอธิบาย"
                                                                                              rows="4"
                                                                                              type="textarea"
                                                                                              className="custom"
                                                                                              style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                                                                              value={selectedRecord.description || ''}
                                                                                              onChange={handleInputChange}
                                                                ></Input>
                                                        </div> 
                                                    </Col>
                                                     {isOwner && !isEditing && (
                                                        <>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <TSText
                                                                        icon="far fa-edit"
                                                                        name="borrowCondition"
                                                                        label="สภาพขณะยืม"
                                                                        value={selectedRecord.borrowCondition || ''}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <FormGroup>
                                                                        <Label>แนบไฟล์ (หลายไฟล์)</Label>
                                                                        <Input
                                                                            type="file"
                                                                            multiple
                                                                            accept=".jpg, .jpeg, .png, .pdf, .docx, .doc, .xlsx, .xls, .pptx, .ppt"
                                                                            onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                        </>
                                                     )}

                                                     {isEditing && (
                                                        <>
                                                         <Col xs={12} sm={12} md={12}>
                                                                                    <div className="textarea-container" style={{ padding: 0 }}>
                                                                                          <Label for="remark">หมายเหตุ </Label>  
                                                                                          <Input
                                                                                              id="remark"
                                                                                              cols="80"
                                                                                              name="remark"
                                                                                              placeholder="หมายเหตุ"
                                                                                              rows="4"
                                                                                              type="textarea"
                                                                                              className="custom"
                                                                                              style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                                                                              value={selectedRecord.remark || ''}
                                                                                              onChange={handleInputChange}
                                                                                              ></Input>
                                                                                      </div>
                                                                                  </Col>

                                                        <Col xs={12} sm={12} md={12} style={{ margin:'10px', background:'#84a3f5'}}>
                                                            <Grid>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <TSText
                                                                        icon="far fa-edit"
                                                                        name="borrowCondition"
                                                                        label="สภาพขณะยืม"
                                                                        value={selectedRecord.borrowCondition || ''}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <FormGroup>
                                                                        <Label>รูปภาพแนบ (ก่อนยืม)</Label>
                                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                                                            {borrowImages && borrowImages.length > 0 ? (
                                                                                borrowImages.map((img, idx) => (
                                                                            
                                                                                    <TSImage
                                                                                        fileID={img.fileId}
                                                                                        key={idx}                      
                                                                                        alt="Borrow Asset"
                                                                                        style={{
                                                                                            //width: '0px',
                                                                                            height: '100px',
                                                                                            objectFit: 'cover',
                                                                                            borderRadius: '5px',
                                                                                            border: '1px solid #ccc',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setPreviewImage(img.fileId);
                                                                                            setPreviewModalOpen(true);
                                                                                        }}
                                                                                    />
                                                                                ))
                                                                            ) : (
                                                                                <small className="text-muted">ไม่มีรูปภาพแนบ</small>
                                                                            )}
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <FormGroup>
                                                                        <Label>แนบไฟล์ (หลายไฟล์)</Label>
                                                                        <Input
                                                                            type="file"
                                                                            multiple
                                                                            accept=".jpg, .jpeg, .png, .pdf, .docx, .doc, .xlsx, .xls, .pptx, .ppt"
                                                                            onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                    
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <Label>ผู้ยืม : {selectedRecord.borrower.firstName} {selectedRecord.borrower.lastName} {selectedRecord.borrower.nickName} {selectedRecord.borrowDT}</Label>
                                                                </Col>
                                                            </Grid>
                                                        </Col>
                                                        <Col xs={12} sm={12} md={12} style={{ margin:'10px', background:'#84f5ce'}}>
                                                            <Grid>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <TSText
                                                                            icon="far fa-edit"
                                                                            name="returnCondition"
                                                                            label="สภาพขณะคืน"
                                                                            value={selectedRecord.returnCondition || ''}
                                                                            onChange={handleInputChange}
                                                                    />
                                                                </Col>                    
        
                                                                <Col xs={12} sm={6} md={6}>
                                                                    <Label>วันที่คืนจริง</Label>
                                                                    <Datetime
                                                                        value={moment(selectedRecord.actualReturnDT).isValid() ? moment(selectedRecord.actualReturnDT) : null}
                                                                        inputProps={{
                                                                            name: "actualReturnDT",
                                                                            placeholder: "วันที่คืนจริง",
                                                                            readOnly: 'readonly',
                                                                            style: {
                                                                                fontSize: '1.2em',
                                                                                borderRadius: 0,
                                                                                paddingLeft: '50px',
                                                                                cursor: 'pointer',
                                                                                background: '#ffffff',
                                                                                color: '#000000'
                                                                            },
                                                                            value: moment(selectedRecord.actualReturnDT).isValid()
                                                                                ? moment(selectedRecord.actualReturnDT).format('D MMMM BBBB')
                                                                                : ''
                                                                        }}
                                                                        closeOnSelect={true}
                                                                        closeOnTab={true}
                                                                        dateFormat="D MMMM BBBB"
                                                                        timeFormat={false}
                                                                        onChange={e => handleSelectChange('actualReturnDT', e != null ? e.format('YYYY-MM-DD') : '')}
                                                                    />
                                                                </Col>   
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <FormGroup>
                                                                        <Label>รูปภาพแนบ (ขณะคืน)</Label>
                                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                                                            {returnImages && returnImages.length > 0 ? (
                                                                                returnImages.map((img, idx) => (
                                                                            
                                                                                    <TSImage
                                                                                        fileID={img.fileId}
                                                                                        key={idx}                      
                                                                                        alt="Borrow Asset"
                                                                                        style={{
                                                                                            //width: '0px',
                                                                                            height: '100px',
                                                                                            objectFit: 'cover',
                                                                                            borderRadius: '5px',
                                                                                            border: '1px solid #ccc',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setPreviewImage(img.fileId);
                                                                                            setPreviewModalOpen(true);
                                                                                        }}
                                                                                    />
                                                                                ))
                                                                            ) : (
                                                                                <small className="text-muted">ไม่มีรูปภาพแนบ</small>
                                                                            )}
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col xs={12} sm={12} md={12}>
                                                                    <FormGroup>
                                                                        <Label>แนบไฟล์ (หลายไฟล์)</Label>
                                                                        <Input
                                                                            type="file"
                                                                            multiple
                                                                            accept=".jpg, .jpeg, .png, .pdf, .docx, .doc, .xlsx, .xls, .pptx, .ppt"
                                                                            onChange={(e) => setSelectedReturnFiles(Array.from(e.target.files))}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>   

                                                                 <Col xs={12} sm={12} md={12}>
                                                                    <Label>ผู้รับคืน : {selectedRecord.receiver?.firstName} {selectedRecord.receiver?.lastName} {selectedRecord.receiver?.nickName}</Label>
                                                                </Col>                               
                                                            </Grid>
                                                        </Col>
                                                          
                                                            <Col xs={12} sm={6} md={6}>
                                                                <TSSelect2
                                                                    label="สถานะ"
                                                                    name="statusKey"
                                                                    options={BorrowStatus}
                                                                    value={selectedRecord.statusKey || ''}
                                                                    onChange={e => handleSelectChange('statusKey', e != null ? e.value : '')}
                                                                />
                                                            </Col>

                                                           
                                                            
                                                        </>
                                                    )}
                                                </Grid>
                                            </CardBody>
                                        </Card>
                                    )}
                                </ModalBody>
                                <ModalFooter>
                                    <Button2
                                        color="info"
                                        type="button"
                                        onClick={openConfirmModal}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button2>
                                    
                                    <Button2
                                        color="danger"
                                        type="button"
                                        onClick={handleCloseModal}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button2>
                                </ModalFooter>
                            </Modal>
                            {/* Preview Modal */}
                            <Modal
                                isOpen={previewModalOpen}
                                toggle={() => setPreviewModalOpen(false)}
                                centered
                                size="xl"
                            >
                                <ModalHeader toggle={() => setPreviewModalOpen(false)}>
                                    <>
                                        <h5 className="mb-0">รูปภาพขยาย</h5>
                                            <Button                                                                                                    
                                                color="primary"                                                                                        
                                                    onClick={handleDownloadImage}                                                                          
                                                    style={{ width: '100%' }}                                                                              
                                                >                                                                                                          
                                                <i className="fa fa-download" /> ดาวน์โหลดรูปภาพ                                                         
                                            </Button>  
                                    </>

                                
                                </ModalHeader>
                                <ModalBody style={{ textAlign: 'center', backgroundColor: '#f8f9fa', overflow: 'auto' }}>
                                    <TSImage
                                        fileID={previewImage}
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '85vh',
                                            objectFit: 'contain',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                                        }}
                                        alt="Preview"
                                    />
                                </ModalBody>
                            </Modal>
                            {/*Confirm*/}
                            <ConfirmModal 
                                isOpen={confirmOpen}
                                toggle={() => setConfirmOpen(false)}
                                onConfirm={handleSaveChanges}
                                title="คุณต้องการยืนยันการบันทึกรายการยืม-คืนนี้ใช่หรือไม่?"
                                isLoading={isLoading}
                            />           

                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
};

export default AssetBorrowList;
